import * as TICKETSTATUSES from './ticketStatuses.constants';
import { TicketStatus } from '../../models';

/** LOAD */
export function loadTicketStatuses() {
    return { type: TICKETSTATUSES.TICKET_STATUSES_LOAD };
}

export function loadTicketStatusesSuccess(data: TicketStatus[]) {
    return { type: TICKETSTATUSES.TICKET_STATUSES_LOAD_SUCCESS, payload: data };
}

export function loadTicketStatusesError(error: any) {
    return { type: TICKETSTATUSES.TICKET_STATUSES_LOAD_ERROR, payload: error };
}


// /** ADD */
// export function addTicketStatuses(targetTicketStatuses: TicketStatuse[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_ADD, payload: targetTicketStatuses };
// }

// export function addTicketStatusesSuccess(targetTicketStatuses: TicketStatuse[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_ADD_SUCCESS, payload: targetTicketStatuses };
// }

// export function addTicketStatusesError(error: any) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_ADD_ERROR, payload: error };
// }


// /** UPDATE */
// export function updateTicketStatuses(targetTicketStatuses: TicketStatuse[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_UPDATE, payload: targetTicketStatuses };
// }

// export function updateTicketStatusesSuccess(targetTicketStatuses: TicketStatuse[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_UPDATE_SUCCESS, payload: targetTicketStatuses };
// }

// export function updateTicketStatusesError(error: any) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_UPDATE_ERROR, payload: error };
// }


// /** DELETE */
// export function deleteTicketStatuses(guids: string[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_DELETE, payload: guids };
// }

// export function deleteTicketStatusesSuccess(TicketStatuses: TicketStatuse[]) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_DELETE_SUCCESS, payload: TicketStatuses };
// }

// export function deleteTicketStatusesError(error: any) {
//     return { type: TICKETSTATUSES.TICKET_STATUSES_DELETE_ERROR, payload: error };
// }